module.exports = __webpack_public_path__ + "img/thumb_27.13773b4e.jpg";